// @ts-nocheck
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { mapea, all, Range, Filter } from './Util/Mapea';
import classNames from 'classnames';
import { Button, ButtonGroup, ButtonToolbar, Card, CardBody, CardTitle, Col, Input, Row } from 'reactstrap';
import { BootstrapTable as BT, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { CSVExport, Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import theme from '../../Theme';
import { inject, observer } from 'mobx-react';
import { loading } from '../../elements/Loading';
import { round, toDate, toDateTime, toMoney } from '../../helpers/Format';
import { T, TT } from 'helpers/i18n';
import { Modal } from '../../components';
import { CheckBox, DatePicker, Loading } from '../../elements';
import { PacketTicket, PaymentMethod, Ticket } from '../Reports/Model';
import SaleTicketCheckin from '../../components/SaleTicketCheckin';
import TicketRenderModal from '../Reports/containers/TicketRenderModal';
import Voucher from '../Vouchers/Model';
import VoucherDetail from '../Reports/containers/VoucherDetail';
import CuadroCard from '../../components/CuadroCard';
import Table2 from '../../Table2';
import PacketTicketDetail from '../Reports/containers/PacketTicketDetail';
import { typeList } from '../Reports/Store';
import { csvVoucherPaymentAfiliateNameFormatter, csvVoucherPaymentFormatter, csvVoucherPaymentMethodFormatter, voucherPaymentAfiliateNameFormatter, voucherPaymentFormatter, voucherPaymentMethodFormatter } from './helpers/vouchers';
import XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
// @ts-ignore
var ExportCSVButton = CSVExport.ExportCSVButton;
var Vista = {
    all: 'all',
    ticket: 'ticket',
    voucher: 'voucher'
};
var defaultRange = Range.Today;
var defaultFilter = Filter.Servicio;
var DashboardTicket = /** @class */ (function (_super) {
    __extends(DashboardTicket, _super);
    function DashboardTicket(props) {
        var _this = _super.call(this, props) || this;
        _this.hiddens = new Set();
        _this.state = {
            tooltip_vouchers: false,
            tooltip_receipt_total: false,
            tooltip_amount_paid: false,
            isLoading: true,
            innerWidth: window.innerWidth,
            radioRangeSelected: defaultRange,
            from: undefined,
            to: undefined,
            datesVisible: false,
            fromVisible: false,
            toVisible: false,
            radioFilterSelected: defaultFilter,
            businessunitSelected: all.allBusiness,
            afiliateSelected: undefined,
            discountReasonSelected: all.allDiscounts,
            categorySelected: all.allCategories,
            showDialog: false,
            toggles: {
                businessUnitName: true,
                payments: true,
                dateSI: true,
                datebook: true,
                daterefund: true,
                datevalited: true,
                destino: true,
                id: true,
                numberSI: true,
                numero: true,
                origin: true,
                stretchName: true,
                terminal: true,
                total: true,
                totalDiscount: true,
                username: true
            },
            columns: initColumns,
            viewSelected: Vista.ticket,
            dateRefunded: null,
            onlyDiscount: true
        };
        _this.categories = function (tickets) {
            var categories = new Set([]);
            tickets.forEach(function (ticket) { return ticket.lines.forEach(function (line) { return categories.add(line.passengerCategoryName); }); });
            // console.log('categories: ', Array.from(categories))
            return Array.from(categories);
        };
        _this.toggleFromModal = function () {
            return _this.setState({ radioRangeSelected: Range.Custom, fromVisible: !_this.state.fromVisible });
        };
        _this.toggleToModal = function () {
            return _this.setState({ radioRangeSelected: Range.Custom, toVisible: !_this.state.toVisible });
        };
        _this.handleFromChange = function (_, from) {
            // this.toggleFromModal()
            _this.setState({ from: from }, function () { return _this.getResult(_this.state.radioRangeSelected, _this.state.from, _this.state.to); });
        };
        _this.handleToChange = function (_, to) {
            // this.toggleToModal()
            _this.setState({ to: to }, function () { return _this.getResult(_this.state.radioRangeSelected, _this.state.from, _this.state.to); });
        };
        _this.handleFromKeyPress = function (keyCode) {
            if (keyCode === 13)
                _this.toggleFromModal();
        };
        _this.handleToKeyPress = function (keyCode) {
            if (keyCode === 13)
                _this.toggleToModal();
        };
        _this.mapeoCategories = function (tickets, category) {
            // console.log('tickets.length: ', tickets.length)
            // console.log('mapeoCategories - category: ', category)
            if (!category || category === all.allCategories)
                return tickets;
            var temp = [];
            tickets.forEach(function (ticket) {
                if (ticket.lines) {
                    ticket.lines.forEach(function (line) {
                        if (line.passengerCategoryName === category) {
                            temp.push(ticket);
                        }
                    });
                }
            });
            // console.log('temp.length: ', temp.length)
            // console.log('temp: ', temp)
            return temp;
        };
        _this.mapeaBusiness = function (tickets, businessunit) {
            // console.log('mapeaFilter - businessunit: ', businessunit)
            if (!businessunit || businessunit === all.allBusiness)
                return tickets;
            return tickets.filter(function (value) { return value.businessUnitName === businessunit; });
        };
        _this.mapeaAfiliate = function (tickets, afiliate) {
            // console.log('mapeaAfiliate - afiliate: ', afiliate)
            if (!afiliate || afiliate === all.allAfiliates || afiliate === '')
                return tickets;
            var temp = [];
            tickets.forEach(function (ticket) {
                if (ticket.payments) {
                    ticket.payments.forEach(function (payment) {
                        if (payment.afiliateName === afiliate) {
                            temp.push(ticket);
                        }
                    });
                }
            });
            return temp;
        };
        _this.mapeaDiscountReason = function (tickets, discountReason) {
            // console.log('mapeaDiscountReason - discountReason: ', discountReason)
            if (!discountReason || discountReason === all.allDiscounts)
                return tickets;
            return tickets.filter(function (value) { return value.discountReason === discountReason; });
        };
        _this.handleChangeBusinessunit = function (data) {
            // console.log('handleChangeBusinessunit - data: ', data.target.value)
            _this.setState({ businessunitSelected: data.target.value });
        };
        _this.handleChangeAfiliate = function (data) {
            // console.log('handleChangeBusinessunit - data: ', data.target.value)
            _this.setState({ afiliateSelected: data.target.value });
        };
        _this.handleChangeDiscountReason = function (data) {
            // console.log('handleChangeDiscountReason - data: ', data.target.value)
            _this.setState({ discountReasonSelected: data.target.value });
        };
        _this.handleChangeCategory = function (data) {
            // console.log('handleChangeCategory - data: ', data.target.value)
            _this.setState({ categorySelected: data.target.value });
        };
        _this.handleToggle = function () {
            _this.setState({ showDialog: false });
        };
        _this.onRefunded = function (response) {
            // console.log('Dashboard - handleRefunded')
            _this.props.store.dashboardTicket.calendarReport(defaultRange, typeList.Report).then(function (value) { return _this.setState({ dateRefunded: new Date() }); });
        };
        _this.chartToShow = function () {
            // ('this.state.radioFilterSelected: ', this.state.radioFilterSelected)
            /*if (this.state.categorySelected !== all.allCategories) {
              return new Set<string>(['checkins'])
            }*/
            if (_this.state.radioFilterSelected === Filter.CategoriaPasajero) {
                return new Set(['checkins']);
            }
            return new Set(['sales', 'checkins', 'tickets']);
        };
        _this.convertToXlsx = function (event) {
            var fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            var fileExtension = '.xlsx';
            var result = _this.filtered.map(function (item) {
                var ticket = __assign({}, item);
                var _loop_1 = function (key) {
                    if (key === 'payments') {
                        // payments y affiliate
                        var payments = '';
                        var afiliateName = '';
                        if (Array.isArray(item.payments) && item.payments.length > 0) {
                            for (var _i = 0, _a = item.payments; _i < _a.length; _i++) {
                                var payment = _a[_i];
                                payments = payments.concat(' ', payment.method);
                                ticket[payment.method] = payment.amount + ' ' + item.money;
                                if (payment.method === PaymentMethod.Credit && payment.afiliateName) {
                                    afiliateName = payment.afiliateName;
                                }
                            }
                        }
                        else {
                            payments = item.tipoPago;
                            ticket[item.tipoPago] = item.total + ' ' + item.money;
                        }
                        ticket.payments = payments;
                        ticket.afiliate = afiliateName;
                    }
                    else if (key === 'lines') {
                        // passengerCategories
                        var hashedPassengers_1 = {};
                        var totalPassengers_1 = 0;
                        item.lines.forEach(function (value, index) {
                            if (hashedPassengers_1.hasOwnProperty(value.passengerCategoryName)) {
                                hashedPassengers_1[value.passengerCategoryName] += value.quantity;
                            }
                            else {
                                hashedPassengers_1[value.passengerCategoryName] = value.quantity;
                            }
                            totalPassengers_1 += value.quantity;
                        });
                        var passenger_1 = '';
                        Object.entries(hashedPassengers_1).forEach(function (_a, index, array) {
                            var clave = _a[0], value = _a[1];
                            // creo la columna con el nombre de la categoría y le asigno el valor
                            ticket[clave] = value;
                            passenger_1 += clave + '-->' + value;
                            if (index !== array.length - 1) {
                                passenger_1 += '\n';
                            }
                        });
                        ticket.totalPassengers = totalPassengers_1;
                        ticket.passenger = passenger_1;
                    }
                };
                for (var key in item) {
                    _loop_1(key);
                }
                var keys2Delete = ['user_id', 'userRefund', 'operationLine_id', 'stretch_id', 'printPrice', 'numberPrinted', 'numberScanned', 'timeExpiration', 'timeAdvance', 'tipoPago',
                    'position', 'packetTicket', 'log', 'timeDelay', 'timeUse', 'horasVuelta', 'aditionalInfo', 'receiptLayout', 'refund_id',
                    'corrected_id', 'stretch', 'ticketRefund', 'user', 'operationLine', 'lines', 'image', 'packet_id', 'taxValue', 'tickets', 'businessUnit', 'client_id', 'operator_id', 'cancelData'];
                keys2Delete.forEach(function (key) { delete ticket[key]; });
                return ticket;
            });
            var json2SheetOpts = {
                header: ['id', 'dateSI', 'numberSI', 'payments', PaymentMethod.Cash, PaymentMethod.Card, PaymentMethod.Credit, 'afiliate', PaymentMethod.Transfer, PaymentMethod.Other,
                    'numero', 'datebook', 'datecheck', 'username', 'terminal'],
                cellDates: true,
                sheetStubs: true,
            };
            var ws = XLSX.utils.json_to_sheet(result, json2SheetOpts);
            var wb = {
                Sheets: { data: ws },
                SheetNames: ['data']
            };
            var execlBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            console.log('wb: ', wb);
            var data = new Blob([execlBuffer], { type: fileType });
            saveAs(data, new Date().toISOString() + fileExtension);
        };
        _this.handleCheckBox = function (checked) {
            _this.setState({ onlyDiscount: checked });
        };
        _this.mapeaToggles = function () {
            var result = {};
            _this.mapeaColumns(_this.state.columns, _this.hiddens).forEach(function (mapeado) {
                result[mapeado.dataField] = !_this.hiddens.has(mapeado.dataField);
            });
            console.log('mapeaToggles - result: ', result);
            return result;
        };
        _this.mapeaColumns = function (columnas, ocultos) {
            var result = columnas.map(function (column) {
                if (ocultos.has(column.dataField)) {
                    // console.log('mapeaColumns - has')
                    column.hidden = true;
                }
                else {
                    column.hidden = false;
                }
                // console.log('mapeaColumns - no has')
                return column;
            });
            // console.log('mapeaColumns - result: ', result)
            return result;
        };
        // console.log('DasboardTicket - constructor')
        // this.state.result = this.props.result
        _this.onRadioBtnClick = _this.onRadioBtnClick.bind(_this);
        var inicioDia = new Date();
        inicioDia.setHours(0, 0, 0, 0);
        var finDia = new Date();
        finDia.setHours(23, 59, 59, 999);
        _this.state.from = inicioDia;
        _this.state.to = finDia;
        return _this;
    }
    DashboardTicket.prototype.componentDidMount = function () {
        // console.log('DasboardTicket - componentDidMount')
        this.onHandleResize.call(this);
        window.addEventListener('resize', this.onHandleResize.bind(this));
        // this.setState({result: this.props.result})
    };
    DashboardTicket.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onHandleResize.bind(this));
    };
    DashboardTicket.prototype.onHandleResize = function () {
        // const isMobile = window.matchMedia('(max-width: 720px)').matches ? true : false
        this.setState({ innerWidth: window.innerWidth });
    };
    DashboardTicket.prototype.getResult = function (radioRangeSelected, from, to) {
        // console.log('DasboardTicket - getResult')
        /*this.props.store!.dashboardTicket.salesReport(radioRangeSelected, from, to).then(value => {
          this.setState({result: value})
        })*/
        // this.props.store.voucherStore.voucherReport(radioRangeSelected, from, to)
        this.props.store.dashboardTicket.calendarReport(radioRangeSelected, typeList.Report, from, to);
    };
    DashboardTicket.prototype.onRadioBtnClick = function (radioRangeSelected) {
        var _this = this;
        this.setState({
            radioRangeSelected: radioRangeSelected
        }, function () {
            if (radioRangeSelected === Range.Custom) {
                _this.getResult(radioRangeSelected, _this.state.from, _this.state.to);
            }
            else {
                _this.getResult(radioRangeSelected);
            }
        });
    };
    DashboardTicket.prototype.onRadioFilterBtnClick = function (value) {
        this.setState({
            radioFilterSelected: value
        });
    };
    DashboardTicket.prototype.handleToggleTooltip = function (id) {
        var key = 'tooltip_' + id;
        var value = !this.state[key];
        var temp = {};
        temp[key] = value;
        this.setState(temp);
    };
    DashboardTicket.prototype.render = function () {
        // console.log('DashboardTicket - render()')
        // console.log('hiddens: ', this.hiddens)
        var _this = this;
        var SearchBar = Search.SearchBar;
        var _a = this.state, from = _a.from, to = _a.to, fromVisible = _a.fromVisible, toVisible = _a.toVisible, radioFilterSelected = _a.radioFilterSelected, businessunitSelected = _a.businessunitSelected, afiliateSelected = _a.afiliateSelected, discountReasonSelected = _a.discountReasonSelected, categorySelected = _a.categorySelected, showDialog = _a.showDialog, columns = _a.columns, radioRangeSelected = _a.radioRangeSelected;
        var _b = this.props, businessunits = _b.businessunits, afiliates = _b.afiliates, discountReasons = _b.discountReasons;
        var maxTo = new Date();
        maxTo.setDate(maxTo.getDate() + 1);
        var innerWidth = this.state.innerWidth;
        var result = this.props.store.dashboardTicket.resultDashboard;
        // console.log('render - result.length', result.length)
        var filtered;
        filtered = this.mapeaBusiness(result, businessunitSelected);
        filtered = this.mapeaAfiliate(filtered, afiliateSelected);
        filtered = this.mapeaDiscountReason(filtered, discountReasonSelected);
        filtered = this.mapeoCategories(filtered, categorySelected);
        if (discountReasonSelected !== all.allDiscounts && this.state.onlyDiscount) {
            filtered = filtered.filter(function (item) { return item.totalDiscount > 0; });
        }
        this.filtered = filtered;
        var categories = this.categories(filtered);
        // console.log('render - filtered', filtered)
        var resultUsuario = mapea(filtered, this.state);
        var resueltoChart = resuelveChart(resultUsuario, radioFilterSelected);
        // const sales = toRound(resultUsuario.total.sales)
        var _c = resultUsuario.total, sales = _c.sales, tickets = _c.tickets, checkins = _c.checkins, canceled = _c.canceled, creditSales = _c.creditSales, creditSalesCanceled = _c.creditSalesCanceled, discount = _c.discount;
        // const resultVoucher = mapeaVouchers(this.props.store.voucherStore._vouchersCalendarReport, this.state)
        // const vouchers = this.props.store.dashboardTicket.getVouchersCalendarReport
        // const resultVoucher = mapeaVouchers(vouchers, this.state)
        var totalSales = sales + canceled /*+ resultVoucher.total.amount_paid*/ + discount;
        var fechas = toDate(from) === toDate(to) ? toDate(from) : "".concat(toDate(from), " - ").concat(toDate(to));
        var title = this.state.radioRangeSelected !== Range.Custom ? TT(this.state.radioRangeSelected) : fechas;
        var subtitle, label, one;
        label = T('sales');
        subtitle = T('sales');
        if (radioFilterSelected === Filter.Afiliate) {
            one = true;
        }
        else if (radioFilterSelected === Filter.DiscountReason) {
            one = true;
        }
        else {
            subtitle = this.state.radioRangeSelected !== Range.Custom ? TT(this.state.radioRangeSelected) : fechas;
            one = false;
        }
        var ticketToRender = this.ticketToRender;
        // console.log('render - resuletoChart.creditSales: ', resueltoChart.creditSales)
        var salesChart = {
            labels: resueltoChart.label,
            datasets: [
                {
                    label: label,
                    data: resueltoChart.creditSales ? resueltoChart.creditSales : resueltoChart.sales
                }
            ]
        };
        var ticketsChart = {
            labels: resueltoChart.label,
            datasets: [
                {
                    label: 'tickets',
                    data: resueltoChart.tickets
                }
            ]
        };
        var checkinsChart = {
            labels: resueltoChart.label,
            datasets: [
                {
                    label: T('checkins'),
                    data: resueltoChart.checkins
                },
                /*{
                  label: 'adulto',
                  data: [51, 2]
                },
                {
                  label: 'niño',
                  data: [15,0]
                },
                {
                  label: 'bebe',
                  data: [5, 0]
                },*/
            ]
        };
        // console.log('sales: ', salesChart)
        var table = resuelveTable(resultUsuario, radioFilterSelected);
        var columnsOK = this.mapeaColumns(columns, this.hiddens);
        var isLoading = !this.props.store.dashboardTicket.loadedCalendar; /*!this.props.store.voucherStore.loaded || !this.props.store.dashboardTicket.loadedSales*/
        // const credited = creditSales + creditSalesCanceled + resultVoucher.total.credit
        // const totalCreditCanceled = creditSalesCanceled
        // const credit = creditSales + resultVoucher.total.credit
        return (React.createElement("div", { className: "animated fadeIn container", style: {
                overflow: 'visible',
                maxWidth: innerWidth < 576 ? (innerWidth - 25) + 'px' : undefined
            } },
            isLoading &&
                React.createElement("div", null,
                    React.createElement(Loading, null)),
            fromVisible && (React.createElement(Modal, { title: T('from') },
                React.createElement(DatePicker, { withTime: true, name: 'from', date: from, onChange: this.handleFromChange, onKeyPress: this.handleFromKeyPress }),
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        border: 'none'
                    } },
                    React.createElement(Button, { style: { backgroundColor: theme.color.background }, onClick: this.toggleFromModal }, 'OK')))),
            toVisible && (React.createElement(Modal, { title: T('to') },
                React.createElement(DatePicker, { max: maxTo, withTime: true, name: 'to', date: to, onChange: this.handleToChange, onKeyPress: this.handleToKeyPress }),
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%'
                    } },
                    React.createElement(Button, { style: { backgroundColor: theme.color.background }, onClick: this.toggleToModal }, 'OK')))),
            React.createElement(Row, { className: "mt-1 mb-4", style: { backgroundColor: 'white', } },
                React.createElement(Col, { className: "col-md-6 col-12 justify-content-sm-start justify-content-md-center justify-content-lg-end " },
                    React.createElement("div", { style: { marginLeft: '1rem', marginTop: '1rem', display: radioRangeSelected === Range.Custom ? 'flex' : 'none' } },
                        React.createElement("div", null,
                            React.createElement("span", null, T('from') + ': '),
                            React.createElement(Button, { onClick: this.toggleFromModal }, toDate(from))),
                        React.createElement("div", null,
                            React.createElement("span", null, T('to') + ': '),
                            React.createElement(Button, { onClick: this.toggleToModal }, toDate(to))))),
                React.createElement(ButtonToolbar, { className: "col-md-6 col-12 justify-content-sm-start justify-content-md-end justify-content-lg-end ", style: { backgroundColor: 'white', }, "aria-label": "Toolbar with button groups" },
                    React.createElement(ButtonGroup, { className: "mr-3 ml-sm-3 mt-3 ml-lg-0", "aria-label": "First group" },
                        React.createElement(Button, { outline: true, style: {
                                color: this.state.radioRangeSelected === Range.Custom ? theme.color.primary : theme.color.secondary
                            }, color: "secondary", onClick: function () { return _this.onRadioBtnClick(Range.Custom); } }, T(Range.Custom)),
                        React.createElement(Button, { outline: true, style: {
                                color: this.state.radioRangeSelected === Range.Today ? theme.color.primary : theme.color.secondary
                                /*background: this.state.radioRangeSelected === Range.Today ? theme.color.hairline : undefined*/
                            }, color: "secondary", onClick: function () { return _this.onRadioBtnClick(Range.Today); } }, T(Range.Today)),
                        React.createElement(Button, { style: {
                                color: this.state.radioRangeSelected === Range.Week ? theme.color.primary : theme.color.secondary
                                /*background: this.state.radioRangeSelected === Range.Week ? theme.color.hairline : undefined*/
                            }, color: "outline-secondary", onClick: function () { return _this.onRadioBtnClick(Range.Week); } }, T(Range.Week)),
                        React.createElement(Button, { style: {
                                color: this.state.radioRangeSelected === Range.Month ? theme.color.primary : theme.color.secondary
                                /*background: this.state.radioRangeSelected === Range.Month ? theme.color.hairline : undefined*/
                            }, color: "outline-secondary", onClick: function () { return _this.onRadioBtnClick(Range.Month); } }, T(Range.Month)),
                        React.createElement(Button, { style: {
                                color: this.state.radioRangeSelected === Range.Year ? theme.color.primary : theme.color.secondary
                                /*background: this.state.radioRangeSelected === Range.Year ? theme.color.hairline : undefined*/
                            }, color: "outline-secondary", onClick: function () { return _this.onRadioBtnClick(Range.Year); } }, T(Range.Year))))),
            React.createElement(Row, { className: "mr-1 ml-1" },
                React.createElement(CuadroCard, { title: title, content: T('totalSales'), value: toMoney(Math.abs(totalSales)) }),
                React.createElement(CuadroCard, { title: title, content: T('totalCanceled'), value: toMoney(0 - canceled) }),
                React.createElement(CuadroCard, { title: title, content: T('sales'), value: toMoney(sales) }),
                React.createElement(CuadroCard, { title: title, content: T('discount'), value: toMoney(discount) }),
                React.createElement(CuadroCard, { title: title, content: 'Tickets', value: String(tickets) }),
                React.createElement(CuadroCard, { title: title, content: T('checkins'), value: String(checkins) })),
            React.createElement(Row, { className: "mr-1 ml-1 mb-4", style: { backgroundColor: 'white', } },
                React.createElement(Col, { className: "col-sm-3 col-12 justify-content-md-start justify-content-center mt-md-0 mt-2" },
                    React.createElement(Input, { type: "select", name: "select", id: "businessunits", value: all.allBusiness, onChange: this.handleChangeBusinessunit },
                        React.createElement("option", { value: all.allBusiness }, T(all.allBusiness)),
                        businessunits.map(function (item) {
                            return React.createElement("option", { key: item.name, value: item.name }, item.name);
                        }))),
                React.createElement(Col, { className: "col-sm-3 col-12 justify-content-md-start justify-content-center mt-md-0 mt-2" },
                    React.createElement(Input, { type: "select", name: "select", id: "afiliates", defaultValue: all.allAfiliates, onChange: this.handleChangeAfiliate },
                        React.createElement("option", { value: all.allAfiliates }, T(all.allAfiliates)),
                        afiliates.map(function (afiliate) {
                            return React.createElement("option", { key: afiliate.id, value: afiliate.name }, afiliate.name);
                        }))),
                React.createElement(Col, { className: "col-sm-3 col-12 justify-content-md-start justify-content-center mt-md-0 mt-2" },
                    React.createElement(Input, { type: "select", name: "select", id: "afiliates", defaultValue: all.allDiscounts, placeholder: T('allAfiliates'), onChange: this.handleChangeDiscountReason },
                        React.createElement("option", { value: all.allDiscounts }, T(all.allDiscounts)),
                        discountReasons.map(function (discountReason) {
                            return React.createElement("option", { key: discountReason.name, value: discountReason.codeDiscount }, discountReason.name);
                        }))),
                React.createElement(Col, { className: "col-sm-3 col-12 justify-content-md-start justify-content-center mt-md-0 mt-2" },
                    React.createElement(Input, { type: "select", name: "select", id: "categories", defaultValue: all.allCategories, placeholder: T('checkins'), onChange: this.handleChangeCategory },
                        React.createElement("option", { value: all.allCategories }, T('checkins')),
                        categories.map(function (category) {
                            return React.createElement("option", { key: category, value: category }, category);
                        })))),
            discountReasonSelected !== all.allDiscounts && React.createElement(Row, { className: "mr-1 ml-1 mb-4" },
                React.createElement(Col, null,
                    React.createElement(CheckBox, { label: 'Listar sólo ventas con descuento', checked: this.state.onlyDiscount, onChange: this.handleCheckBox }))),
            React.createElement(Row, { className: "right mr-1 ml-1 mb-4" },
                React.createElement(ButtonToolbar, { className: "col-12 justify-content-md-end justify-content-start mt-md-0 mt-2", style: { backgroundColor: 'white', }, "aria-label": "Toolbar with button groups" },
                    React.createElement(ButtonGroup, { className: "", style: { backgroundColor: 'white' }, "aria-label": "Second group" },
                        React.createElement(ItemRadioFiltered, { primary: this.state.radioFilterSelected === Filter.Afiliate, text: T('afiliate'), onRadioFilterBtnClick: function () { return _this.onRadioFilterBtnClick(Filter.Afiliate); } }),
                        React.createElement(ItemRadioFiltered, { primary: this.state.radioFilterSelected === Filter.DiscountReason, text: T('codeDiscount'), onRadioFilterBtnClick: function () { return _this.onRadioFilterBtnClick(Filter.DiscountReason); } }),
                        React.createElement(ItemRadioFiltered, { primary: this.state.radioFilterSelected === Filter.User, text: T('user'), onRadioFilterBtnClick: function () { return _this.onRadioFilterBtnClick(Filter.User); } }),
                        React.createElement(ItemRadioFiltered, { primary: this.state.radioFilterSelected === Filter.LineaOperacion, text: T('operationLine'), onRadioFilterBtnClick: function () { return _this.onRadioFilterBtnClick(Filter.LineaOperacion); } }),
                        React.createElement(ItemRadioFiltered, { primary: this.state.radioFilterSelected === Filter.Packet, text: T('packet'), onRadioFilterBtnClick: function () { return _this.onRadioFilterBtnClick(Filter.Packet); } }),
                        React.createElement(ItemRadioFiltered, { primary: this.state.radioFilterSelected === Filter.Servicio, text: T('servicio'), onRadioFilterBtnClick: function () { return _this.onRadioFilterBtnClick(Filter.Servicio); } }),
                        React.createElement(ItemRadioFiltered, { primary: this.state.radioFilterSelected === Filter.CollaboratorService, text: T('collaboratorService'), onRadioFilterBtnClick: function () { return _this.onRadioFilterBtnClick(Filter.CollaboratorService); } }),
                        React.createElement(ItemRadioFiltered, { primary: this.state.radioFilterSelected === Filter.CategoriaPasajero, text: T('categoriaPasajero'), onRadioFilterBtnClick: function () { return _this.onRadioFilterBtnClick(Filter.CategoriaPasajero); } })))),
            React.createElement(Row, { className: "justify-content-center" },
                React.createElement("div", { className: classNames('col-12') },
                    React.createElement(SaleTicketCheckin, { salesChart: salesChart, ticketsChart: ticketsChart, checkinsChart: checkinsChart, cardChartOpts: cardChartOpts4, title: title, subtitle: subtitle, one: one, charToShow: this.chartToShow() }))),
            React.createElement(Row, { className: "mr-1 ml-1" },
                React.createElement("div", { className: "col-12 col-sm-12" },
                    React.createElement(Card, null,
                        React.createElement(CardBody, null,
                            React.createElement(Row, { className: "mb-1" },
                                React.createElement("div", { className: "col-12 col-sm-12" },
                                    React.createElement(CardTitle, { className: "mb-1" }, ''),
                                    React.createElement("div", { className: "small text-muted mt-1" }, title))),
                            React.createElement(BT, { exportCSV: true, data: table, version: "4", striped: true, hover: true, pagination: true, search: true, options: tableOptions, csvFileName: "result_".concat(new Date().toLocaleString(), ".csv") },
                                React.createElement(TableHeaderColumn, { dataField: "username", dataSort: true, isKey: true }, T(radioFilterSelected)),
                                this.chartToShow().has('sales') && React.createElement(TableHeaderColumn, { dataField: "ventas", dataSort: true }, T('sales')),
                                this.chartToShow().has('tickets') && React.createElement(TableHeaderColumn, { dataField: "tickets", dataSort: true }, "Tickets"),
                                this.chartToShow().has('checkins') && React.createElement(TableHeaderColumn, { dataField: "checkins", dataSort: true }, "Checkins")))))),
            React.createElement(Row, { className: "mr-1 ml-1" },
                React.createElement(Table2, { xlxs: this.convertToXlsx, cardTitle: title, columns: columns, data: filtered, keyField: 'id', rowStyle: rowStyle, rowEvents: {
                        onClick: function (e, row, rowIndex) {
                            // console.log('row: ', row)
                            if (row instanceof PacketTicket) {
                                _this.ticketToRender = row;
                                _this.setState({ showDialog: true });
                                return;
                            }
                            var item = new Ticket(row);
                            if (item.daterefund) {
                                _this.props.store.reports.readTicketCorrected(item.id).then(function (ticketCorrected) {
                                    // console.log('ticketCorrected: ', ticketCorrected)
                                    // controlo si es cancelado por método nuevo (con ticket rectificación) o antiguo
                                    if (ticketCorrected) {
                                        // this.setState({showDialog: true, ticketToRender: item, ticketCorrectedToRender: ticketCorrected})
                                        _this.ticketToRender = item;
                                        _this.ticketCorrectedToRender = ticketCorrected;
                                        _this.setState({ showDialog: true });
                                    }
                                    else {
                                        // this.setState({showDialog: true, ticketToRender: item, ticketCorrectedToRender: undefined})
                                        _this.ticketToRender = item;
                                        _this.ticketCorrectedToRender = null;
                                        _this.setState({ showDialog: true });
                                    }
                                });
                            }
                            else {
                                // this.setState({showDialog: true, ticketToRender: item, ticketCorrectedToRender: undefined})
                                _this.ticketToRender = item;
                                _this.ticketCorrectedToRender = null;
                                _this.setState({ showDialog: true });
                            }
                            _this.setState({ showDialog: true });
                        }
                    } })),
            showDialog && (ticketToRender instanceof PacketTicket) && React.createElement(PacketTicketDetail, { item: ticketToRender, onToggle: this.handleToggle }),
            showDialog && (ticketToRender instanceof Ticket) && React.createElement(TicketRenderModal, { ticket: ticketToRender, onToggle: this.handleToggle, onRefunded: this.onRefunded }),
            showDialog && (ticketToRender instanceof Voucher) && React.createElement(VoucherDetail, { voucher: ticketToRender, onToggle: this.handleToggle })));
    };
    DashboardTicket = __decorate([
        inject('store'),
        loading(function (props) { return [
            // props.store!.dashboardTicket.salesReport(Range.Today).then(ticketsResult => ({ticketsResult})),
            props.store.businessUnits.read().then(function (businessunits) {
                // console.log('businessunits: ', businessunits)
                return { businessunits: businessunits };
            }),
            props.store.afiliateStore.read().then(function (afiliates) {
                // console.log('afiliates: ', afiliates)
                return { afiliates: afiliates };
            }),
            props.store.discountReasonStore.read().then(function (discountReasons) {
                // console.log('discountReasons: ', discountReasons)
                return { discountReasons: discountReasons };
            }),
            // props.store.voucherStore.voucherReport(Range.Today).then(vouchersResult => ({vouchersResult})),
            props.store.dashboardTicket.calendarReport(defaultRange, typeList.Report).then(function (result) { return result; })
        ]; }),
        observer
    ], DashboardTicket);
    return DashboardTicket;
}(Component));
var cardChartOpts4 = {
    tooltips: {
        yAlign: 'bottom',
        enabled: true,
        responsive: true
        /*custom: CustomTooltips,*/
    },
    maintainAspectRatio: false,
    legend: {
        display: true,
        position: 'left'
    },
    elements: {
        rectangle: {
            backgroundColor: '#C2194244',
            borderColor: theme.color.primary,
            borderWidth: 0.5
        }
    },
    layout: {
        padding: {
            top: 100
        }
    },
    scales: {
        xAxes: [
            {
                display: true,
                barPercentage: '1.1',
                gridLines: {
                    color: theme.color.hairline,
                    zeroLineColor: 'transparent'
                },
                ticks: {
                    fontSize: 12,
                    fontColor: theme.color.secondary,
                    fontFamily: 'Lato'
                }
            }
        ],
        yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
    }
};
var tableOptions = {
    sortIndicator: true,
    hideSizePerPage: true,
    paginationSize: 3,
    hidePageListOnlyOnePage: true,
    clearSearch: false,
    alwaysShowAllBtns: true,
    withFirstAndLast: true,
};
var styleCuadroCard = {
    background: 'white', height: '150px', color: theme.color.secondary, borderColor: theme.color.primary
};
var styleChartF = function (numero, innerWidth) {
    // console.error('numero', numero)
    // console.error('innerWidth', innerWidth)
    var result;
    var factor = 24;
    if (innerWidth < 768) {
        factor = 8;
    } /* else if (innerWidth < 992) {
      factor = 24
    } else if (innerWidth < 1200) {
      factor = 32
    }*/
    // console.error('factor', factor)
    if (numero > factor) {
        result = (Math.trunc(numero * 1000 / 42)) + 'px';
    }
    else {
        result = '100%';
    }
    // console.error('result', result)
    // console.log('*********************************************************')
    return {
        height: '340px',
        marginTop: '20px',
        overflowX: 'auto',
        paddingTop: '0px',
        width: result,
        background: 'rgba(161,159,161,0.02)'
    };
};
var resuelveChart = function (data, type) {
    // console.log('resuelveChart() - data: ', data)
    var operarios = Object.keys(data.operarios);
    var lineasOperacion = Object.keys(data.lineasOperacion);
    var paquetes = Object.keys(data.packets);
    var servicios = Object.keys(data.servicios);
    var collaboratorServices = Object.keys(data.collaboratorServices);
    var afiliados = Object.keys(data.afiliados);
    var discounReasons = Object.keys(data.discountReasons);
    var categories = Object.keys(data.categories);
    // console.log('DasboardTicket - resuelveChart operarios: ', operarios)
    var salesUser = operarios.map(function (value) { return round(data.operarios[value].sales); });
    var salesLineasOperacion = lineasOperacion.map(function (value) { return round(data.lineasOperacion[value].sales); });
    var salesPaquetes = paquetes.map(function (value) { return round(data.packets[value].sales); });
    var salesServicios = servicios.map(function (value) { return round(data.servicios[value].sales); });
    var salesCollaboratorServices = collaboratorServices.map(function (value) { return round(data.collaboratorServices[value].sales); });
    var salesAfiliate = afiliados.map(function (value) { return round(data.afiliados[value].sales); });
    var creditSalesAfiliate = afiliados.map(function (value) { return round(data.afiliados[value].creditSales); });
    var salesDiscount = discounReasons.map(function (value) { return round(data.discountReasons[value].sales); });
    var salesCategory = categories.map(function (value) { return round(data.categories[value].sales); });
    // console.log('DasboardTicket - resuelveChart - sales: ', sales)
    var ticketsUser = operarios.map(function (value) { return data.operarios[value].tickets; });
    var ticketsLineasOperacion = lineasOperacion.map(function (value) { return data.lineasOperacion[value].tickets; });
    var ticketsPaquetes = paquetes.map(function (value) { return data.packets[value].tickets; });
    var ticketsServicios = servicios.map(function (value) { return data.servicios[value].tickets; });
    var ticketsCollaboratorServices = collaboratorServices.map(function (value) { return data.collaboratorServices[value].tickets; });
    var ticketsAfiliate = afiliados.map(function (value) { return data.afiliados[value].tickets; });
    var ticketsDiscount = discounReasons.map(function (value) { return data.discountReasons[value].tickets; });
    var ticketsCategory = categories.map(function (value) { return data.categories[value].tickets; });
    // console.log('DasboardTicket - resuelveChart - tickets: ', tickets)
    var checkinsUser = operarios.map(function (value) { return data.operarios[value].checkins; });
    var checkinsLineasOperacion = lineasOperacion.map(function (value) { return data.lineasOperacion[value].checkins; });
    var checkinsPaquetes = paquetes.map(function (value) { return data.packets[value].checkins; });
    var checkinsServicios = servicios.map(function (value) { return data.servicios[value].checkins; });
    var checkinsCollaboratorServices = collaboratorServices.map(function (value) { return data.collaboratorServices[value].checkins; });
    var chekinsAfiliate = afiliados.map(function (value) { return data.afiliados[value].checkins; });
    var checkinsDiscount = discounReasons.map(function (value) { return data.discountReasons[value].checkins; });
    var checkinsCategory = categories.map(function (value) { return data.categories[value].checkins; });
    // console.log('DasboardTicket - resuelveChart checkins: ', checkins)
    var resultLabel, sales, tickets, checkins, creditSales;
    switch (type) {
        case Filter.User:
            resultLabel = operarios;
            sales = salesUser;
            tickets = ticketsUser;
            checkins = checkinsUser;
            break;
        case Filter.LineaOperacion:
            resultLabel = lineasOperacion;
            sales = salesLineasOperacion;
            tickets = ticketsLineasOperacion;
            checkins = checkinsLineasOperacion;
            break;
        case Filter.Packet:
            resultLabel = paquetes;
            sales = salesPaquetes;
            tickets = ticketsPaquetes;
            checkins = checkinsPaquetes;
            break;
        case Filter.Servicio:
            resultLabel = servicios;
            sales = salesServicios;
            tickets = ticketsServicios;
            checkins = checkinsServicios;
            break;
        case Filter.CollaboratorService:
            resultLabel = collaboratorServices;
            sales = salesCollaboratorServices;
            tickets = ticketsCollaboratorServices;
            checkins = checkinsCollaboratorServices;
            break;
        case Filter.Afiliate:
            resultLabel = afiliados;
            sales = salesAfiliate;
            tickets = ticketsAfiliate;
            checkins = chekinsAfiliate;
            creditSales = creditSalesAfiliate;
            break;
        case Filter.DiscountReason:
            resultLabel = discounReasons;
            sales = salesDiscount;
            tickets = ticketsDiscount;
            checkins = checkinsDiscount;
            break;
        case Filter.CategoriaPasajero:
            resultLabel = categories;
            sales = salesCategory;
            tickets = ticketsCategory;
            checkins = checkinsCategory;
            break;
        default:
    }
    return {
        label: resultLabel,
        sales: sales,
        tickets: tickets,
        checkins: checkins,
        creditSales: creditSales
    };
};
var resuelveTable = function (data, type) {
    var result = resuelveChart(data, type);
    var table = [];
    for (var i = 0; i < result.label.length; i++) {
        var temp = {};
        temp.username = result.label[i];
        temp.ventas = round(result.sales[i], 2);
        temp.tickets = result.tickets[i];
        temp.checkins = result.checkins[i];
        table.push(temp);
    }
    return table;
};
var rowStyle = function (row, index) {
    if (row.daterefund || row.refund_id) {
        return { color: theme.color.primary };
    }
    else {
        return {};
    }
};
var headerFormatter = function (column, colIndex) {
    return (React.createElement("h6", { style: { minWidth: '120px' } }, column.text));
};
var headerAttrs = function () {
    return {};
};
var headerStyle = {
    'width': '120px',
};
var paymentsHeaderStyle = {
    'width': '200px',
};
var dateCellFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (row.daterefund || row.refund_id) {
        return React.createElement("span", { style: { color: theme.color.primary } }, cell ? toDate(cell) : '');
    }
    return React.createElement("span", null, cell ? toDate(cell) : '');
};
var dateTimeCellFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (row.daterefund || row.refund_id) {
        return React.createElement("span", { style: { color: theme.color.primary } }, cell ? toDateTime(cell) : '');
    }
    return React.createElement("span", null, cell ? toDateTime(cell) : '');
};
var dateCsvFormatter = function (cell, row, rowIndex) {
    return cell ? toDate(cell) : '';
};
var dateTimeCsvFormatter = function (cell, row, rowIndex) {
    return cell ? toDateTime(cell) : '';
};
var moneyCsvFormatter = function (cell, row, rowIndex) {
    return cell ? toMoney(cell) : '';
};
var cellCsvFormatter = function (cell, row, rowIndex) {
    return cell ? cell : '';
};
var paymentsFormatter = function (cell, row, rowIndex, formatExtraData) {
    // console.log('pagos - :', row)
    if (row instanceof Voucher) {
        return null;
    }
    if (row.payments && row.payments.length > 1) {
        return React.createElement("div", null, row.payments.map(function (payment, index) {
            if (payment.method === PaymentMethod.Credit) {
                return React.createElement("div", { key: payment.method + payment.afiliateName + index.toString(), style: { fontWeight: 'bold', marginTop: '5px', marginBottom: '5px' } },
                    React.createElement("div", { key: payment.method }, "".concat(T(payment.method), ": ").concat(toMoney(payment.amount))),
                    React.createElement("div", { style: { marginLeft: '15px' }, key: payment.afiliateName }, "".concat(payment.afiliateName)));
            }
            return React.createElement("div", { style: { marginTop: '5px', marginBottom: '5px' }, key: payment.method }, "".concat(T(payment.method), ": ").concat(toMoney(payment.amount)));
        }));
    }
    else if (row.payments && row.payments.length === 1) {
        return React.createElement("div", null, React.createElement("span", null, "".concat(T(row.payments[0].method))));
    }
    else {
        return React.createElement("div", null, React.createElement("span", null, "".concat(T(row.tipoPago))));
    }
};
var csvPaymentFormatter = function (cell, row, rowIndex) {
    console.log('csvFormatter - cell: ', cell);
    var result = '';
    if (cell && cell.length > 0) { // lógica de pago nueva
        cell.forEach(function (payment, index) {
            result += "".concat(T(payment.method), ": ").concat(toMoney(payment.amount));
            if (payment.method === PaymentMethod.Credit) {
                result += " --> ".concat(payment.afiliateName);
            }
            if (index < cell.length) {
                result += '\n';
            }
        });
    }
    else { // lógica de pago antigua
        result = "".concat((row.tipoPago), ": ").concat(toMoney(row.total));
    }
    return result;
};
var csvPaymentCashFormatter = function (cell, row, rowIndex) {
    console.log('csvFormatter - cell: ', cell);
    var result = '';
    if (cell && cell.length > 0) { // lógica de pago nueva
        cell.forEach(function (payment, index) {
            if (payment.method === PaymentMethod.Cash) {
                result += "".concat(toMoney(payment.amount));
            }
        });
    }
    else { // lógica de pago antigua
        if (row.tipoPago === PaymentMethod.Cash)
            result = "".concat(toMoney(row.total));
    }
    return result;
};
var csvPaymentCardFormatter = function (cell, row, rowIndex) {
    console.log('csvFormatter - cell: ', cell);
    var result = '';
    if (cell && cell.length > 0) { // lógica de pago nueva
        cell.forEach(function (payment, index) {
            if (payment.method === PaymentMethod.Card) {
                result += "".concat(toMoney(payment.amount));
            }
        });
    }
    else { // lógica de pago antigua
        if (row.tipoPago === PaymentMethod.Card) {
            result = "".concat(toMoney(row.total));
        }
    }
    return result;
};
var csvPaymentCreditFormatter = function (cell, row, rowIndex) {
    console.log('csvFormatter - cell: ', cell);
    var result = '';
    if (cell && cell.length > 0) { // lógica de pago nueva
        cell.forEach(function (payment, index) {
            if (payment.method === PaymentMethod.Credit) {
                result += "".concat(toMoney(payment.amount));
            }
        });
    }
    return result;
};
var csvAffiliateFormatter = function (cell, row, rowIndex) {
    console.log('csvFormatter - cell: ', cell);
    var result = '';
    if (cell && cell.length > 0) { // lógica de pago nueva
        cell.forEach(function (payment, index) {
            if (payment.method === PaymentMethod.Credit) {
                result += "".concat(payment.afiliateName);
            }
        });
    }
    return result;
};
var csvPaymentTransferFormatter = function (cell, row, rowIndex) {
    console.log('csvFormatter - cell: ', cell);
    var result = '';
    if (cell && cell.length > 0) { // lógica de pago nueva
        cell.forEach(function (payment, index) {
            if (payment.method === PaymentMethod.Transfer) {
                result += "".concat(toMoney(payment.amount));
            }
        });
    }
    return result;
};
var csvPaymentOtherFormatter = function (cell, row, rowIndex) {
    console.log('csvFormatter - cell: ', cell);
    var result = '';
    if (cell && cell.length > 0) { // lógica de pago nueva
        cell.forEach(function (payment, index) {
            if (payment.method === PaymentMethod.Other) {
                result += "".concat(toMoney(payment.amount));
            }
        });
    }
    return result;
};
var paymentCashFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (row instanceof Voucher) {
        return null;
    }
    if (row.payments && row.payments.length > 0) {
        return React.createElement("div", null, row.payments.map(function (payment, index) {
            if (payment.method === PaymentMethod.Cash) {
                return React.createElement("div", { key: payment.method, style: { fontWeight: 'bold', marginTop: '5px', marginBottom: '5px' } },
                    React.createElement("div", null, "".concat(toMoney(payment.amount))));
            }
            return React.createElement("div", { style: { marginTop: '5px', marginBottom: '5px' }, key: payment.method }, '-');
        }));
    }
    else {
        if (row.tipoPago === PaymentMethod.Cash) {
            return React.createElement("div", null, React.createElement("span", null, toMoney(row.total)));
        }
        return React.createElement("div", null, React.createElement("span", null, ''));
    }
};
var paymentCardFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (row instanceof Voucher) {
        return null;
    }
    if (row.payments && row.payments.length > 0) {
        return React.createElement("div", null, row.payments.map(function (payment, index) {
            if (payment.method === PaymentMethod.Card) {
                return React.createElement("div", { key: payment.method, style: { fontWeight: 'bold', marginTop: '5px', marginBottom: '5px' } },
                    React.createElement("div", null, "".concat(toMoney(payment.amount))));
            }
            return React.createElement("div", { style: { marginTop: '5px', marginBottom: '5px' }, key: payment.method }, '');
        }));
    }
    else {
        if (row.tipoPago === PaymentMethod.Card) {
            return React.createElement("div", null, React.createElement("span", null, toMoney(row.total)));
        }
        return React.createElement("div", null, React.createElement("span", null, ''));
    }
};
var paymentCreditFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (row instanceof Voucher) {
        return null;
    }
    if (row.payments && row.payments.length > 0) {
        return React.createElement("div", null, row.payments.map(function (payment, index) {
            if (payment.method === PaymentMethod.Credit) {
                return React.createElement("div", { key: payment.method + payment.afiliateName, style: { fontWeight: 'bold', marginTop: '5px', marginBottom: '5px' } },
                    React.createElement("div", { key: payment.method }, "".concat(toMoney(payment.amount))));
            }
            return React.createElement("div", { style: { marginTop: '5px', marginBottom: '5px' }, key: payment.method }, '');
        }));
    }
    else {
        return React.createElement("div", null, React.createElement("span", null, ''));
    }
};
var paymentAfiliateNameFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (row instanceof Voucher) {
        return null;
    }
    if (row.payments && row.payments.length > 0) {
        return React.createElement("div", null, row.payments.map(function (payment, index) {
            if (payment.method === PaymentMethod.Credit) {
                return React.createElement("div", { key: payment.method + payment.afiliateName, style: { fontWeight: 'bold', marginTop: '5px', marginBottom: '5px' } },
                    React.createElement("div", { style: { marginLeft: '15px' }, key: payment.afiliateName }, "".concat(payment.afiliateName)));
            }
            return React.createElement("div", { style: { marginTop: '5px', marginBottom: '5px' }, key: payment.method }, '');
        }));
    }
    else {
        return React.createElement("div", null, React.createElement("span", null, ''));
    }
};
var paymentTransferFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (row instanceof Voucher) {
        return null;
    }
    if (row.payments && row.payments.length > 0) {
        return React.createElement("div", null, row.payments.map(function (payment, index) {
            if (payment.method === PaymentMethod.Transfer) {
                return React.createElement("div", { key: payment.method, style: { fontWeight: 'bold', marginTop: '5px', marginBottom: '5px' } },
                    React.createElement("div", null, "".concat(toMoney(payment.amount))));
            }
            return React.createElement("div", { style: { marginTop: '5px', marginBottom: '5px' }, key: payment.method }, '');
        }));
    }
    else {
        return React.createElement("div", null, React.createElement("span", null, ''));
    }
};
var paymentOtherFormatter = function (cell, row, rowIndex, formatExtraData) {
    if (row instanceof Voucher) {
        return null;
    }
    if (row.payments && row.payments.length > 0) {
        return React.createElement("div", null, row.payments.map(function (payment, index) {
            if (payment.method === PaymentMethod.Other) {
                return React.createElement("div", { key: payment.method, style: { fontWeight: 'bold', marginTop: '5px', marginBottom: '5px' } },
                    React.createElement("div", null, "".concat(toMoney(payment.amount))));
            }
            return React.createElement("div", { style: { marginTop: '5px', marginBottom: '5px' }, key: payment.method }, '');
        }));
    }
    else {
        return React.createElement("div", null, React.createElement("span", null, ''));
    }
};
var paymentCsvFormatter = function (cell, row, rowIndex) {
    console.log('csvFormatter - cell: ', cell);
    var result = '';
    if (cell && cell.length > 0) { // lógica de pago nueva
        cell.forEach(function (payment, index) {
            if (payment.method === PaymentMethod.Other) {
                result += "".concat(toMoney(payment.amount));
            }
        });
    }
    else { // lógica de pago antigua
        result = "".concat(toMoney(row.total));
    }
    return result;
};
var initColumnsVoucher = [
    // @ts-ignore
    { dataField: 'display_id', text: 'display_id', sort: true, title: function (cell, row, rowIndes, colIndex) { return "".concat(cell); }, headerStyle: headerStyle },
    {
        dataField: 'payments',
        keyField: 'payment',
        text: T('payments'),
        headerStyle: __assign(__assign({}, paymentsHeaderStyle), { minWidth: '300px' }),
        formatter: voucherPaymentFormatter,
        csvFormatter: csvVoucherPaymentFormatter
    },
    {
        dataField: 'payments',
        keyField: 'paymentCash',
        text: T('cash'),
        headerStyle: headerStyle,
        formatter: function (cell, row, rowIndex, formatExtraData) { return voucherPaymentMethodFormatter(PaymentMethod.Cash, cell, row, rowIndex, formatExtraData); },
        csvFormatter: function (cell, row, rowIndex, formatExtraData) { return csvVoucherPaymentMethodFormatter(PaymentMethod.Cash, cell, row, rowIndex, formatExtraData); }
    },
    {
        dataField: 'payments',
        keyField: 'paymentCard',
        text: T('card'),
        headerStyle: headerStyle,
        formatter: function (cell, row, rowIndex, formatExtraData) { return voucherPaymentMethodFormatter(PaymentMethod.Card, cell, row, rowIndex, formatExtraData); },
        csvFormatter: function (cell, row, rowIndex, formatExtraData) { return csvVoucherPaymentMethodFormatter(PaymentMethod.Card, cell, row, rowIndex, formatExtraData); }
    },
    {
        dataField: 'payments',
        keyField: 'paymentCredit',
        text: T('credit'),
        headerStyle: headerStyle,
        formatter: function (cell, row, rowIndex, formatExtraData) { return voucherPaymentMethodFormatter(PaymentMethod.Credit, cell, row, rowIndex, formatExtraData); },
        csvFormatter: function (cell, row, rowIndex, formatExtraData) { return csvVoucherPaymentMethodFormatter(PaymentMethod.Credit, cell, row, rowIndex, formatExtraData); }
    },
    {
        dataField: 'payments',
        keyField: 'paymentTransfer',
        text: T('transfer'),
        headerStyle: headerStyle,
        formatter: function (cell, row, rowIndex, formatExtraData) { return voucherPaymentMethodFormatter(PaymentMethod.Transfer, cell, row, rowIndex, formatExtraData); },
        csvFormatter: function (cell, row, rowIndex, formatExtraData) { return csvVoucherPaymentMethodFormatter(PaymentMethod.Transfer, cell, row, rowIndex, formatExtraData); }
    },
    {
        dataField: 'payments',
        keyField: 'paymentOther',
        text: T('other'),
        headerStyle: headerStyle,
        formatter: function (cell, row, rowIndex, formatExtraData) { return voucherPaymentMethodFormatter(PaymentMethod.Other, cell, row, rowIndex, formatExtraData); },
        csvFormatter: function (cell, row, rowIndex, formatExtraData) { return csvVoucherPaymentMethodFormatter(PaymentMethod.Other, cell, row, rowIndex, formatExtraData); }
    },
    {
        dataField: 'payments',
        keyField: 'paymentAfiliate',
        text: T('afiliate'),
        headerStyle: __assign(__assign({}, paymentsHeaderStyle), { minWidth: '300px' }),
        formatter: function (cell, row, rowIndex, formatExtraData) { return voucherPaymentAfiliateNameFormatter(cell, row, rowIndex, formatExtraData); },
        csvFormatter: csvVoucherPaymentAfiliateNameFormatter
    },
    {
        dataField: 'invoice_price',
        text: ('precio factura'),
        headerStyle: headerStyle,
        formatter: function (cell, row, rowIndex, formatExtraData) { return row.invoice_price ? toMoney(row.invoice_price / 100) : ''; },
        csvFormatter: function (cell, row, rowIndex) { return row.invoice_price ? toMoney(row.invoice_price / 100) : ''; }
    },
];
var initColumns = [
    // @ts-ignore
    { dataField: 'id', text: 'id', sort: true, title: function (cell, row, rowIndex, colIndex) { return "".concat(cell); }, headerStyle: headerStyle },
    { dataField: 'numberSI', text: T('invoiceSimple'), headerStyle: headerStyle },
    { dataField: 'payments', keyField: 'paymentCash', text: T('paymentCash'), headerStyle: headerStyle, formatter: paymentCashFormatter, title: function () { return 'pagado en efectivo'; },
        csvFormatter: csvPaymentCashFormatter },
    { dataField: 'payments', keyField: 'paymentCard', text: T('paymentCard'), headerStyle: headerStyle, formatter: paymentCardFormatter, title: function () { return 'pagado en tarjeta'; },
        csvFormatter: csvPaymentCardFormatter },
    {
        dataField: 'payments', keyField: 'paymentCredit', text: T('paymentCredit'),
        headerStyle: headerStyle,
        formatter: paymentCreditFormatter, title: function () { return 'pago crédito'; },
        csvFormatter: csvPaymentCreditFormatter
    },
    { dataField: 'payments', keyField: 'afiliate', text: T('afiliate'), headerStyle: headerStyle, formatter: paymentAfiliateNameFormatter,
        csvFormatter: csvAffiliateFormatter },
    { dataField: 'payments', keyField: 'paymentTransfer', text: T('paymentTransfer'), headerStyle: headerStyle, formatter: paymentTransferFormatter,
        csvFormatter: csvPaymentTransferFormatter },
    { dataField: 'payments', keyField: 'paymentOther', text: T('paymentOther'), headerStyle: headerStyle, formatter: paymentOtherFormatter,
        csvFormatter: csvPaymentOtherFormatter },
    {
        dataField: 'payments',
        text: T('payments'),
        headerStyle: paymentsHeaderStyle,
        formatter: paymentsFormatter,
        csvFormatter: csvPaymentFormatter
    },
    { dataField: 'dateSI', text: T('dateSI'), headerStyle: headerStyle,
        formatter: dateCellFormatter,
        csvFormatter: dateCsvFormatter },
    { dataField: 'datebook', text: T('datebook'), headerStyle: headerStyle,
        formatter: dateTimeCellFormatter,
        csvFormatter: dateTimeCsvFormatter,
    },
    {
        dataField: 'daterefund',
        text: T('dateRefund'),
        formatter: dateTimeCellFormatter,
        csvFormatter: dateTimeCsvFormatter,
        // @ts-ignore
        headerAttrs: headerAttrs,
        // @ts-ignore
        title: function (cell, row, rowIndex, colIndex) { return "".concat(cell ? cell : ''); },
        headerStyle: headerStyle
    },
    { dataField: 'datevalited', text: T('dateValited'), headerStyle: headerStyle,
        formatter: dateTimeCellFormatter, csvFormatter: dateTimeCsvFormatter },
    { dataField: 'numero', text: T('number'), sort: true, headerStyle: headerStyle },
    { dataField: 'businessUnitName', text: T('business'), sort: true, headerStyle: headerStyle },
    { dataField: 'stretchName', text: T('servicio'), sort: true, headerStyle: headerStyle },
    { dataField: 'origin', text: T('origin'), sort: true, headerStyle: headerStyle, csvFormatter: cellCsvFormatter },
    { dataField: 'destination', text: T('destination'), sort: true, headerStyle: headerStyle, csvFormatter: cellCsvFormatter },
    { dataField: 'username', text: T('seller'), sort: true, headerStyle: headerStyle },
    { dataField: 'terminal', text: T('terminal'), sort: true, headerStyle: headerStyle, csvFormatter: cellCsvFormatter },
    { dataField: 'total', text: T('total'), sort: true, headerStyle: headerStyle, csvFormatter: moneyCsvFormatter },
    { dataField: 'totalDiscount', text: T('totalDiscount'), sort: true, headerStyle: headerStyle, csvFormatter: moneyCsvFormatter },
];
export var MyExportCSV = function (props) {
    var handleClick = function (event) {
        props.onExport();
    };
    return (React.createElement("div", null,
        React.createElement("button", { type: "button", className: "btn btn-success react-bs-table-csv-btn btn-sm hidden-print", onClick: handleClick },
            React.createElement("span", null,
                React.createElement("i", { className: "fa glyphicon glyphicon-export fa-download" }),
                " Export to CSV"))));
};
var ItemRadioFiltered = function (_a) {
    var primary = _a.primary, onRadioFilterBtnClick = _a.onRadioFilterBtnClick, text = _a.text;
    return (React.createElement(Button, { outline: true, style: {
            color: primary ? theme.color.primary : theme.color.secondary
        }, onClick: onRadioFilterBtnClick }, text));
};
var titleStyle = { color: theme.color.primary };
export default DashboardTicket;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DashboardTicket/index.tsx
// module id = 335
// module chunks = 0